import React, {Dispatch, SetStateAction, useCallback, useMemo, useState} from 'react';

import {SelectInterface} from '@veneer/core';

import {ManagementActionType} from '@br/idm-api';

import {useManagementActionTypeNames} from '../../i18n';

import SelectFilter from './SelectFilter';

const ManagementActionFilter = <K extends string, F extends Partial<Record<K, ManagementActionType>>>({
    field,
    label,
    filters,
    setFilters,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
}): JSX.Element => {
    const actionNames = useManagementActionTypeNames();

    const [actionFilter, setActionFilter] = useState('');

    const filteredActions = useMemo(() => {
        const filter = actionFilter.toLocaleLowerCase();
        return Object.entries(actionNames)
            .filter(([, value]) => value.toLocaleLowerCase().includes(filter))
            .map(([key, value]) => ({value: parseInt(key, 10), label: value}));
    }, [actionNames, actionFilter]);

    const handleSearch = useCallback<Required<SelectInterface>['onSearch']>(query => setActionFilter(query || ''), []);

    return (
        <SelectFilter
            data-testid="management-action-filter"
            label={label}
            field={field}
            options={filteredActions}
            showSearch
            onSearch={handleSearch}
            filters={filters}
            setFilters={setFilters}
        />
    );
};

export default ManagementActionFilter;
